{
  "apiUrl": "/bp-api",
  "environment": "local",
  "auth": {
    "audience": "https://archintegrate-nonprod.archinsurance.com",
    "issuer": "https://archinsurance-dev.auth0.com/",
    "clientId": "qxoqosdlQ8uW66D8XE9k0Sx1VyxZXYBw",
    "grant_type": "client_credentials"
  }
}
